export default "__VITE_ASSET__5634a8cb__"